import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import HttpHelper from 'Services/HttpHelper'

export async function getDictionary(country, page) {
    const url = `${ServerEnv.MemberCalls2()}/hot/dictionary/v2/publish/${country}/feelgreat`

    return (await axios.get(HttpHelper.Proxy({ originalUrl: url }))).data
}
